import api from "!../../../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../css-loader/dist/cjs.js??ref--17-1!../../../../../postcss-loader/dist/cjs.js??ref--17-2!./JsonDisplayBrick.module.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};